export enum ActiveTab {
  Register = 'Register',
  Address = 'Country/State',
  Security = 'Security',
  Login = 'Login',
}
